import { useContext } from 'react';
import {
    Button, Row, Col,
} from 'reactstrap';
import { getShort } from '@s20/common/util/date';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import CommonContext from '../Common';


export const EmployeeCountyIncentiveInfo = ({ incentives, onAddIncentive, onEditIncentive }) => {
    const { formIsOpen } = useContext(CommonContext);

    return (
        <>
            <Row className="pb-1">
                <Col>
                    <div className="d-flex flex-row align-items-center justify-content-end">
                        <Can
                            I="edit"
                            a="employee"
                        >
                            <SmallButton
                                disabled={!!formIsOpen}
                                type="button"
                                onClick={onAddIncentive}
                            >
                                <i className="fa fa-plus-circle fa-md mr-2" />
                                Add Incentive
                            </SmallButton>
                        </Can>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <table className="table table-sm table-bordered">
                        <thead className="text-muted">
                            <tr>
                                <th>County</th>
                                <th>Incentive Amount</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <Can
                                    I="edit"
                                    a="employee"
                                >
                                    <th
                                        className="text-center"
                                        style={{ width: '30px' }}
                                    />
                                </Can>
                            </tr>
                        </thead>
                        <tbody>
                            {!(incentives ?? []).length ? (
                                <tr>
                                    <td
                                        colSpan="5"
                                        className="text-center"
                                    >
                                        No incentives found.
                                    </td>
                                </tr>
                            ) : (
                                incentives.map((incentive) => {
                                    let endDate = '';

                                    if (incentive.endDate != null) {
                                        endDate = getShort(incentive.endDate);
                                    } else if (incentive.endDate == '' || incentive.endDate == null) {
                                        endDate = 'Current';
                                    }

                                    return (
                                        <tr key={incentive.id}>
                                            <td>
                                                {incentive.countyName}
                                            </td>
                                            <td>
                                                {parseFloat(incentive.incentiveAmount).toFixed(2)}
                                            </td>
                                            <td>
                                                {getShort(
                                                    incentive.startDate,
                                                )}
                                            </td>
                                            <td>
                                                {endDate}
                                            </td>
                                            <Can
                                                I="edit"
                                                a="employee"
                                            >
                                                <td>
                                                    <Button
                                                        disabled={!!formIsOpen}
                                                        type="button"
                                                        color="outline-primary"
                                                        onClick={() => onEditIncentive(incentive)}
                                                        size="sm"
                                                    >
                                                        Edit
                                                    </Button>
                                                </td>
                                            </Can>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
    );
};